import React, { FC, memo } from 'react';
import { useField } from 'formik';

import usePrefix from 'utils/usePrefix';
import TextAreaComponent from 'components/TextAreaComponent';
import FormDescription from 'components/ResqlExpert/FormDescription';
import { FormSectionStyled, TabBodyContentStyled } from 'components/ResqlExpert/SubmissionForm/styles';

const Retrospective: FC = () => {
  const t = usePrefix('ResqlExpert');
  const [shortTermField, , shortTermHelpers] = useField<string>('short_term_objectives');
  const [longTermField, , longTermHelpers] = useField<string>('long_term_objectives');
  const shortTerm = shortTermField.value ?? '';
  const longTerm = longTermField.value ?? '';

  return (
    <TabBodyContentStyled>
      <FormSectionStyled>
        <FormDescription title={t('tab_goals')}>
          <p>{t('tab_goals_hint')}</p>
        </FormDescription>
        <TextAreaComponent
          id="short_term_objectives"
          label={t('tab_goals_short_term')}
          placeholder={t('tab_goals_short_term')}
          text={shortTerm}
          setText={(v) => shortTermHelpers.setValue(v)}
        />
        <TextAreaComponent
          id="long_term_objectives"
          label={t('tab_goals_long_term')}
          placeholder={t('tab_goals_long_term')}
          text={longTerm}
          setText={(v) => longTermHelpers.setValue(v)}
        />
      </FormSectionStyled>
    </TabBodyContentStyled>
  );
};

export default memo(Retrospective);
